import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class ContractATCForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("proj_contract_id", true);
          this.props.setFieldTouched("atc_status_id", true);
          this.props.setFieldTouched("atc_cost_savings", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <small className={"d-block col-12"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label
            className="col-12"
            style={
              this.props.errors.atc_cost_savings &&
              this.props.touched.atc_cost_savings && { color: "red" }
            }
          >
            ATC Cost Savings
            <Field
              className="form-control-sm form-control"
              name={"atc_cost_savings"}
              value={this.props.values.atc_cost_savings || null}
            />
            {this.props.errors.atc_cost_savings &&
              this.props.touched.atc_cost_savings && (
                <small className="text-danger">
                  {this.props.errors.atc_cost_savings}
                </small>
              )}
          </label>
          <label className="col-12">
            ATC Other Impact
            <Field
              className="form-control-sm form-control"
              name={"atc_other_impact"}
              value={this.props.values.atc_other_impact || ""}
            />
          </label>
          <div>
            <SelectionFields
              showError={
                this.props.errors.atc_status_id &&
                this.props.touched.atc_status_id
              }
              size={"col-12"}
              id={"atc_status_id"}
              url={"atc_status_lkp"}
              showElem={"name"}
              label={"ATC Status"}
              value={this.props.values["atc_status_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.atc_status_id &&
                this.props.touched.atc_status_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.atc_status_id}
                  </small>
                )
              }
            />
          </div>
          <label className="col-12">
            Name
            <Field
              className="form-control-sm form-control"
              name={"name"}
              value={this.props.values.name || ""}
            />
          </label>
          <label className="col-12">
            ATC Time Savings
            <Field
              className="form-control-sm form-control"
              name={"atc_time_savings"}
              value={this.props.values.atc_time_savings || ""}
            />
          </label>
          <div>
            <SelectionFields
              showError={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id
              }
              size={"col-12"}
              id={"proj_contract_id"}
              url={`proj_contract/project_id/${this.props.projectID}`}
              showElem={"contra" + "ct_name"}
              label={"Contract"}
              value={this.props.values["proj_contract_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.proj_contract_id}
                  </small>
                )
              }
            />
          </div>
          <label className="col-12">
            Proposer
            <Field
              className="form-control-sm form-control"
              name={"proposer"}
              value={this.props.values.proposer || ""}
            />
          </label>
          <label className="col-12">
            Description
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"description"}
              value={this.props.values.description || ""}
            />
          </label>
          <label className="col-12">
            Notes
            <Field
              component={"textarea"}
              rows={4}
              className="form-control-sm form-control"
              name={"notes"}
              value={this.props.values.notes || ""}
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            className={"ml-2"}
            type="button"
            onClick={this.props.toggleSmallModalHandler}
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentContractATC ? (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.add, this.props.values);
                  }}
                >
                  Submit
                </Button>
                <Button
                  color={"red"}
                  className={"ml-2"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            ) : (
              <Aux>
                <Button
                  type="button"
                  color={"blue"}
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                <Button
                  className={"ml-2"}
                  color={"red"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            )}
            <Button
              className={"ml-2"}
              type="button"
              onClick={this.props.toggleSmallModalHandler}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var contractATCSchema = Yup.object().shape({
  proj_contract_id: Yup.string().required(),
  atc_status_id: Yup.string().required(),
  atc_cost_savings: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  validationSchema: contractATCSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractATC }) {
    return {
      ...currentContractATC
    };
  }
})(ContractATCForm);
